import { Box, UseRadioProps, useRadio, useStyleConfig } from '@chakra-ui/react';

import { SwitchGroupOptionType } from '../SwitchGroup.types';

export const SwitchGroupButton: React.FC<
  SwitchGroupOptionType & UseRadioProps
> = ({ icon: Icon, friendlyValue, radioButtonProps, size, ...props }) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const styles = useStyleConfig('Button', {
    size,
  });

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label" flex={1}>
      <input {...input} />
      <Box
        {...checkbox}
        __css={styles}
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        padding={0}
        cursor="pointer"
        borderRadius="full"
        color="primary.300"
        fontSize="xs"
        fontWeight={500}
        backgroundColor="transparent"
        _active={{ color: 'primary.500', backgroundColor: 'white' }}
        _focus={{ outline: 'none' }}
        _checked={{
          color: 'primary.500',
          backgroundColor: 'white',
        }}
        _hover={{
          color: 'primary.500',
          backgroundColor: props.isChecked ? 'none' : 'primary.100',
        }}
        {...radioButtonProps}
        track-id={props.dataHeapTrack}
      >
        {Icon ? <Icon boxSize={4} /> : friendlyValue}
      </Box>
    </Box>
  );
};
